{
  "Accessibility Menu": "Toegankelijkheidsmenu",
  "Reset settings": "Instellingen resetten",
  "Close": "Sluiten",
  "Content Adjustments": "Inhoudsaanpassingen",
  "Adjust Font Size": "Lettergrootte aanpassen",
  "Highlight Title": "Titel markeren",
  "Highlight Links": "Links markeren",
  "Readable Font": "Leesbaar lettertype",
  "Color Adjustments": "Kleur aanpassingen",
  "Dark Contrast": "Donker contrast",
  "Light Contrast": "Licht contrast",
  "High Contrast": "Hoog contrast",
  "High Saturation": "Hoge verzadiging",
  "Low Saturation": "Lage verzadiging",
  "Monochrome": "Monochroom",
  "Tools": "Gereedschappen",
  "Reading Guide": "Leesgids",
  "Stop Animations": "Animaties stoppen",
  "Big Cursor": "Grote cursor",
  "Increase Font Size": "Lettergrootte vergroten",
  "Decrease Font Size": "Lettergrootte verkleinen",
  "Letter Spacing": "Letterafstand",
  "Line Height": "Regelhoogte",
  "Font Weight": "Letterdikte",
  "Dyslexia Font": "Dyslexie lettertype",
  "Language": "Taal",
  "Open Accessibility Menu": "Toegankelijkheidsmenu openen"
}
